import { StyleRules } from '@material-ui/core/styles';
import { TypographyClassKey } from '@material-ui/core/Typography';

import { core as theme } from '../styles/core';
import { MOBILE_FONT_SIZE } from '../styles/constants/MOBILE_FONT_SIZE';

export const MuiTypography: Partial<StyleRules<TypographyClassKey>> = {
  h1: {
    [theme.breakpoints.down('md')]: {
      fontSize: `${MOBILE_FONT_SIZE.h1}rem`,
    },
  },
  h2: {
    [theme.breakpoints.down('md')]: {
      fontSize: `${MOBILE_FONT_SIZE.h2}rem`,
    },
  },
  h3: {
    [theme.breakpoints.down('md')]: {
      fontSize: `${MOBILE_FONT_SIZE.h3}rem`,
    },
  },
  h4: {
    [theme.breakpoints.down('md')]: {
      fontSize: `${MOBILE_FONT_SIZE.h4}rem`,
    },
  },
  h5: {
    [theme.breakpoints.down('md')]: {
      fontSize: `${MOBILE_FONT_SIZE.h5}rem`,
    },
  },
  h6: {
    [theme.breakpoints.down('md')]: {
      fontSize: `${MOBILE_FONT_SIZE.h6}rem`,
    },
  },
};
